import listActions from 'src/modules/entitlement/list/entitlementListActions';
import EntitlementService from 'src/modules/entitlement/entitlementService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'ENTITLEMENT_UNARCHIVE';

const entitlementUnarchiveActions = {
  UNARCHIVE_STARTED: `${prefix}_UNARCHIVE_STARTED`,
  UNARCHIVE_SUCCESS: `${prefix}_UNARCHIVE_SUCCESS`,
  UNARCHIVE_ERROR: `${prefix}_UNARCHIVE_ERROR`,

  UNARCHIVE_ALL_STARTED: `${prefix}_UNARCHIVE_ALL_STARTED`,
  UNARCHIVE_ALL_SUCCESS: `${prefix}_UNARCHIVE_ALL_SUCCESS`,
  UNARCHIVE_ALL_ERROR: `${prefix}_UNARCHIVE_ALL_ERROR`,

  doUnarchive: (id) => async (dispatch) => {
    try {
      dispatch({
        type: entitlementUnarchiveActions.UNARCHIVE_STARTED,
      });

      await EntitlementService.unarchiveAll([id]);

      dispatch({
        type: entitlementUnarchiveActions.UNARCHIVE_SUCCESS,
      });

      Message.success(
        i18n('entities.entitlement.unarchive.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: entitlementUnarchiveActions.UNARCHIVE_ERROR,
      });
    }
  },

  doUnarchiveAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type:
          entitlementUnarchiveActions.UNARCHIVE_ALL_STARTED,
      });

      await EntitlementService.unarchiveAll(ids);

      dispatch({
        type:
          entitlementUnarchiveActions.UNARCHIVE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.entitlement.unarchiveAll.success'),
      );

      getHistory().push('/entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type:
          entitlementUnarchiveActions.UNARCHIVE_ALL_ERROR,
      });
    }
  },
};

export default entitlementUnarchiveActions;
